// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__f3ibu"};